<!-- Header: always rendered when collapsible so it stays tappable in the offline state. -->
<header
  class="nova-card__header"
  *ngIf="collapsible || card?.title"
  [class.nova-card__header--clickable]="collapsible"
  (click)="toggleHeader()">
  <h3 class="nova-card__title">{{ card?.title || fallbackTitle || ('AI_SUMMARY' | translate) }}</h3>
  <button
    type="button"
    class="nova-card__maximize"
    *ngIf="collapsible && !isCollapsed && !offline"
    [attr.aria-label]="isMaximized ? ('READ_LESS' | translate) : ('READ_MORE' | translate)"
    (click)="toggleMaximize(); $event.stopPropagation()">
    <ion-icon [name]="isMaximized ? 'contract-outline' : 'expand-outline'" aria-hidden="true"></ion-icon>
  </button>
</header>

<!-- Offline body: only shown when the host provides a localized message (the brief surface). -->
<div class="nova-card__offline" *ngIf="offline && offlineMessage; else onlineBody">
  <ion-icon name="cloud-offline-outline" class="nova-card__offline-icon" aria-hidden="true"></ion-icon>
  <p class="nova-card__offline-text">{{ offlineMessage }}</p>
</div>

<ng-template #onlineBody>
  <!-- Body — hidden entirely when collapsed or when the card is offline. -->
  <div class="nova-card__body-wrap" *ngIf="!isCollapsed && !offline">

    <!-- Loading skeleton -->
    <div class="nova-card__skeleton" *ngIf="loading">
      <ion-skeleton-text class="nova-card__skeleton-line" [animated]="true"></ion-skeleton-text>
      <ion-skeleton-text class="nova-card__skeleton-line nova-card__skeleton-line--partial" [animated]="true"></ion-skeleton-text>
    </div>

    <ng-container *ngIf="!loading">
      <div
        class="nova-card__body"
        [class.nova-card__clamp]="isMinimized"
        *ngIf="hasContent">
        <nova-section
          *ngFor="let section of card!.sections; trackBy: trackSection"
          [section]="section"
          (openEntity)="openEntity.emit($event)"
          (action)="onAction($event)">
        </nova-section>
      </div>

      <!-- Read-more affordance (minimized clamp) -->
      <p class="nova-card__read-more" *ngIf="isMinimized && hasReadMore">
        <a class="nova-card__read-link" (click)="toggleMaximize(); $event.stopPropagation()">{{ 'READ_MORE' | translate }}</a>
      </p>
      <p class="nova-card__read-less" *ngIf="isMaximized">
        <a class="nova-card__read-link" (click)="toggleMaximize(); $event.stopPropagation()">{{ 'READ_LESS' | translate }}</a>
      </p>

      <!-- Card-level action chips — suppressed on non-latest assistant turns via [actionsActive]. -->
      <card-actions
        *ngIf="actionsActive && card?.actions?.length"
        class="nova-card__actions"
        [actions]="card!.actions"
        (action)="onAction($event)">
      </card-actions>
    </ng-container>

    <!-- Footer: disclaimer + per-response feedback (vote + token usage) -->
    <footer class="nova-card__footer" *ngIf="(disclaimer || responseId) && !loading">
      <span class="nova-card__disclaimer" *ngIf="disclaimer">{{ disclaimer }}</span>
      <nova-feedback-footer
        [responseId]="responseId"
        [usage]="usage"
        (feedback)="feedback.emit($event)">
      </nova-feedback-footer>
    </footer>
  </div>
</ng-template>
